<template>
  <div
    class="border-light-border dark:border-dark-semi-transparent bg-light-white dark:bg-dark-black mt-2 flex w-full flex-row items-center justify-around border-t p-3 sm:relative sm:h-20 sm:justify-between sm:border-none sm:bg-inherit sm:px-0 dark:sm:bg-inherit"
  >
    <slot />
  </div>
</template>
